export default {"src":"/_next/static/media/NZFlag.a4606171.svg","height":24,"width":32};